import React from "react";
import { Text } from "../../components/Text";
import { CareerData } from "../career.data";
import { CvAvatar } from "../career-icon";
import { useTranslation } from "react-i18next";
import { Tag } from "../../components/tag";
import { Card, CardContent } from "../../components/card";

interface TimelineShowcaseProps {
  entry: CareerData;
}

export default function TimelineShowcase({ entry }: TimelineShowcaseProps) {
  const { t } = useTranslation("cv");
  return (
    <Card>
      <CardContent className="flex gap-4 items-center">
        <CvAvatar type={entry.type} />
        <div className="flex flex-col">
          <Text variant="body1" component="span">{t(entry.position)}</Text>
          <Text variant="caption" component="span">{t(entry.company)}</Text>
        </div>
      </CardContent>
      {entry.description.length ? (
        <CardContent>
          {entry.description.map((tKey, i) => (
            <Text key={i} align="justify">
              {t(tKey)}
            </Text>
          ))}
        </CardContent>
      ) : null}
      {entry.tags ? (
        <CardContent>
          <div className="flex justify-center flex-wrap gap-2">
            {entry.tags.map((tag, i) => (
              <Tag key={i}>
                {tag}
              </Tag>
            ))}
          </div>
        </CardContent>
      ) : null}
    </Card>
  );
}
